import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { store } from "@store";
import { App } from "./App";
import "./index.scss";
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(App, null)), document.getElementById("app"));
